import { BaseService } from "./base.service";
import gateway from "@interceptors/gateway.interceptor";
import { CardSuggestionTranslationModel } from "@models/card-suggestion-translation.model";

class CardSuggestionService extends BaseService {
    public deleteCardSuggestion = async (id: number) => {
        const url = `/card-suggestions/delete/${id}`;
        const response = await gateway.delete(url);
        return response.data;
    }

    public createCardSuggestion = async (idCardInfoParent: string, formData: FormData, cardSuggestionModel: any) => {
        const url = '/card-suggestions/save';
        const dto = this.cardSuggestionConverter.modelToDto(cardSuggestionModel);
        const bodyJsonString = JSON.stringify(dto);
        formData.append('body', new Blob([bodyJsonString], { type: 'application/json' }));
        const response = await gateway.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            params: {
                "idCardInfo": idCardInfoParent
            }
        })
        return response.data;
    }

    public getCardSuggestion = async (idCard: string) => {
        const url = `/card-suggestions/find/${idCard}`;
        const response = await gateway.get(url); 
        return response.data;
    }

    public updateCardSuggestion = async (idCardInfoParent: string, formData: FormData, cardSuggestionModel: CardSuggestionTranslationModel, idcardSuggestion: string) => {
        const url = `/card-suggestions/update/${idcardSuggestion}`;
        const dto = this.cardSuggestionConverter.modelToDto(cardSuggestionModel);

        const bodyJsonString = JSON.stringify(dto);
        formData.append('body', new Blob([bodyJsonString], { type: 'application/json' }));    
        const response = await gateway.put(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        return response.data;
    }
}

export default new CardSuggestionService();